
    export default 
    {
    "tutorial_over_modal": {
        "dec": "Por favor, dirígete a Shopify - Ajustes - Verifica si estás utilizando la función de autoprocesamiento, si es así, por favor desactívala y guarda la nueva configuración.",
        "dec2": "Ten en cuenta que la función de autoprocesamiento de Shopify ejecutará automáticamente los pedidos, evitando que los envíes a AliExpress. Si tienes esta función activada en Shopify, no podrás procesar pedidos en Dsers."
    }
}